import { TCompanyBranch, TCompanyForm } from "@/features/company/types/CompanyForm";
import { FC } from "react";
import { InnerBox } from "@/components/elements/InnerBox";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { Grid, Typography } from "@mui/material";
import { CompanyInfoItem } from "@/features/company/components/company-detail/CompanyInfoItem";

type TCompanyBranchDetailProps = {
  defaultValues?: Partial<TCompanyForm>;
};
export const CompanyBranchDetail: FC<TCompanyBranchDetailProps> = ({ defaultValues }) => {
  const companyBranch = defaultValues?.companyBranches || [];
  const title = (index: number) => (companyBranch.length > 1 ? `事業所 ${index + 1}` : `事業所`);
  return (
    <InnerBox title={<CompanyFormTitle text="事業所情報" />} showDivider={false}>
      {companyBranch.map((office: TCompanyBranch, index: number) => (
        <InnerBox
          title={<Typography variant="sub16Bold">{title(index)}</Typography>}
          showDivider={false}
          sx={{
            marginBottom: "16px",
          }}
        >
          <Grid container key={index} spacing={3}>
            <Grid item xs={12}>
              <CompanyInfoItem label="事業所名" value={office?.branchName} />
            </Grid>
            <Grid item xs={4}>
              <CompanyInfoItem label="郵便番号" value={office?.zipCode} type="zipcode" />
            </Grid>
            <Grid item xs={4}>
              <CompanyInfoItem label="都道府県" value={office?.prefecture} />
            </Grid>
            <Grid item xs={4}>
              <CompanyInfoItem label="市区町村" value={office?.city} />
            </Grid>
            <Grid item xs={12}>
              <CompanyInfoItem label="市区町村以降の住所" value={office?.address} />
            </Grid>
            <Grid item xs={6}>
              <CompanyInfoItem label="事業所代表電話番号" value={office?.telNumber} type="phone" />
            </Grid>
            <Grid item xs={6}>
              <CompanyInfoItem label="FAX番号" value={office?.faxNumber} type="phone" />
            </Grid>
            <Grid item xs={12}>
              <CompanyInfoItem label="この事業所について" value={office?.branchDescription} isShowDivider={false} />
            </Grid>
          </Grid>
        </InnerBox>
      ))}
    </InnerBox>
  );
};
